import { getSupabase } from '@/hooks/useSupabase';

const supabase = getSupabase;

// ─── Tipler ───
export interface Musteri {
  id: number; ad_soyad: string; telefon: string; alternatif_telefon: string; eposta: string;
  tc_no: string; sehir: string; kaynak_id: number; etiketler: string; durum: string;
  toplam_konaklama: number; son_konaklama: string; toplam_harcama: number; notlar: string;
  aktif: boolean; silindi: boolean;
}

export interface Oda {
  id: number; oda_no: string; oda_tipi_id: number; oda_tipi_adi: string; kapasite: number;
  kat: string; durum: string; temizlik_durumu: string; bakim_durumu: string;
  mutfak_var: boolean; balkon_var: boolean; klima_var: boolean; yatak_duzeni: string;
  aktif: boolean; silindi: boolean;
}

export interface Rezervasyon {
  id: number; rezervasyon_no: string; musteri_id: number; oda_id: number | null;
  giris_tarihi: string; cikis_tarihi: string; gece_sayisi: number; yetiskin_sayisi: number;
  cocuk_sayisi: number; kisi_sayisi: number; oda_tipi: string; durum: string;
  odeme_durumu: string; gecelik_fiyat: number; toplam_tutar: number; odenen_toplam: number;
  alinan_kapora: number; kalan_tutar: number; kahvalti_dahil: boolean; ek_yatak: boolean;
  odeme_yontemi: string; kaynak_id: number; kaynak_detay: string; kampanya_adi: string;
  giris_saati: string; cikis_saati: string; notlar: string; aktif: boolean; silindi: boolean;
}

export interface Odeme {
  id: number; rezervasyon_id: number; musteri_id: number; tutar: number;
  odeme_turu: string; odeme_yontemi: string; aciklama: string; odeme_tarihi: string;
  aktif: boolean; silindi: boolean;
}

export interface Teklif {
  id: number; musteri_id: number; musteri_adi: string; musteri_telefon: string;
  talep_tarihi: string; istenen_giris: string; istenen_cikis: string; kisi_sayisi: number;
  oda_tercihi: string; verilen_fiyat: number; kaynak_id: number; durum: string;
  son_takip_tarihi: string; son_not: string; aktif: boolean; silindi: boolean;
  donusen_rez_id?: number;
}

export interface Gorev {
  id: number; baslik: string; musteri_adi: string; rezervasyon_id: number;
  tarih: string; oncelik: string; durum: string; sorumlu: string; aciklama: string;
  tur: string; aktif: boolean; silindi: boolean;
  gorev_oda_id?: number; saat?: string;
}

export interface Kaynak { id: number; ad: string; aktif: boolean; sira: number; }
export interface OdaTipi { id: number; ad: string; kapasite: number; mutfak_var: boolean; balkon_var: boolean; klima_var: boolean; yatak_duzeni: string; aktif: boolean; sira: number; }
export interface OtelAyar { anahtar: string; deger: string; }
export interface WhatsAppSablon { id: number; anahtar: string; baslik: string; mesaj: string; aktif: boolean; }
export interface Personel { id: number; ad_soyad: string; rol: string; telefon: string; }
export interface TemizlikKaydi { id: number; oda_id: number; temizlik_durumu: string; personel: string; aciklama: string; olusturma_tarihi: string; }
export interface RezervasyonGecmisi { id: number; rezervasyon_id: number; onceki_durum: string; yeni_durum: string; onceki_odeme: string; yeni_odeme: string; onceki_oda_id: number; yeni_oda_id: number; aciklama: string; islem: string; olusturma_tarihi: string; }

// ─── Müşteriler ───
export async function fetchMusteriler() {
  const { data, error } = await getSupabase().from('ilkimbutik_musteriler').select('*').eq('silindi', false).order('olusturma_tarihi', { ascending: false });
  if (error) throw error;
  return data as Musteri[];
}

export async function fetchMusteri(id: number) {
  const { data, error } = await getSupabase().from('ilkimbutik_musteriler').select('*').eq('id', id).single();
  if (error) throw error;
  return data as Musteri;
}

export async function createMusteri(musteri: Partial<Musteri>) {
  const { data, error } = await getSupabase().from('ilkimbutik_musteriler').insert(musteri).select().single();
  if (error) throw error;
  return data as Musteri;
}

export async function updateMusteri(id: number, updates: Partial<Musteri>) {
  const { data, error } = await getSupabase().from('ilkimbutik_musteriler').update({ ...updates, guncelleme_tarihi: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as Musteri;
}

// ─── Odalar ───
export async function fetchOdalar() {
  const { data, error } = await getSupabase().from('ilkimbutik_odalar').select('*').eq('silindi', false).order('oda_no');
  if (error) throw error;
  return data as Oda[];
}

export async function createOda(oda: Partial<Oda>) {
  const { data, error } = await getSupabase().from('ilkimbutik_odalar').insert(oda).select().single();
  if (error) throw error;
  return data as Oda;
}

export async function updateOda(id: number, updates: Partial<Oda>) {
  const { data, error } = await getSupabase().from('ilkimbutik_odalar').update({ ...updates, guncelleme_tarihi: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as Oda;
}

export async function softDeleteOda(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_odalar').update({ silindi: true, aktif: false, silinme_tarihi: new Date().toISOString(), guncelleme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}

// ─── Rezervasyonlar ───
export async function fetchRezervasyonlar() {
  const { data, error } = await getSupabase().from('ilkimbutik_rezervasyonlar').select('*').eq('silindi', false).order('olusturma_tarihi', { ascending: false });
  if (error) throw error;
  return data as Rezervasyon[];
}

export async function fetchRezervasyon(id: number) {
  const { data, error } = await getSupabase().from('ilkimbutik_rezervasyonlar').select('*').eq('id', id).single();
  if (error) throw error;
  return data as Rezervasyon;
}

export async function createRezervasyon(rez: Partial<Rezervasyon>) {
  const { data, error } = await getSupabase().from('ilkimbutik_rezervasyonlar').insert(rez).select().single();
  if (error) throw error;
  return data as Rezervasyon;
}

export async function updateRezervasyon(id: number, updates: Partial<Rezervasyon>) {
  const { data, error } = await getSupabase().from('ilkimbutik_rezervasyonlar').update({ ...updates, guncelleme_tarihi: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as Rezervasyon;
}

export async function softDeleteRezervasyon(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_rezervasyonlar').update({ silindi: true, silinme_tarihi: new Date().toISOString(), guncelleme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}

export async function checkOdaConflict(odaId: number, giris: string, cikis: string, excludeRezId?: number) {
  let query = getSupabase().from('ilkimbutik_rezervasyonlar').select('id').eq('oda_id', odaId).eq('silindi', false).in('durum', ['kapora_bekleniyor', 'rezervasyon_onaylandi', 'giris_yapildi', 'konakliyor']).lt('giris_tarihi', cikis).gt('cikis_tarihi', giris);
  if (excludeRezId) query = query.neq('id', excludeRezId);
  const { data, error } = await query;
  if (error) throw error;
  return data && data.length > 0;
}

// ─── Ödemeler ───
export async function fetchOdemeler() {
  const { data, error } = await getSupabase().from('ilkimbutik_odemeler').select('*').eq('silindi', false).order('odeme_tarihi', { ascending: false });
  if (error) throw error;
  return data as Odeme[];
}

export async function fetchOdemelerByRezervasyon(rezervasyonId: number) {
  const { data, error } = await getSupabase().from('ilkimbutik_odemeler').select('*').eq('rezervasyon_id', rezervasyonId).eq('silindi', false).order('odeme_tarihi', { ascending: false });
  if (error) throw error;
  return data as Odeme[];
}

export async function createOdeme(odeme: Partial<Odeme>) {
  const { data, error } = await getSupabase().from('ilkimbutik_odemeler').insert(odeme).select().single();
  if (error) throw error;
  return data as Odeme;
}

export async function cancelOdeme(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_odemeler').update({ aktif: false, silindi: true, silinme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}

// ─── Teklifler ───
export async function fetchTeklifler() {
  const { data, error } = await getSupabase().from('ilkimbutik_teklifler').select('*').eq('silindi', false).order('olusturma_tarihi', { ascending: false });
  if (error) throw error;
  return data as Teklif[];
}

export async function createTeklif(teklif: Partial<Teklif>) {
  const { data, error } = await getSupabase().from('ilkimbutik_teklifler').insert(teklif).select().single();
  if (error) throw error;
  return data as Teklif;
}

export async function updateTeklif(id: number, updates: Partial<Teklif>) {
  const { data, error } = await getSupabase().from('ilkimbutik_teklifler').update({ ...updates, guncelleme_tarihi: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as Teklif;
}

export async function softDeleteTeklif(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_teklifler').update({ silindi: true, aktif: false, silinme_tarihi: new Date().toISOString(), guncelleme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}

// ─── Görevler ───
export async function fetchGorevler() {
  const { data, error } = await getSupabase().from('ilkimbutik_gorevler').select('*').eq('silindi', false).order('tarih', { ascending: false });
  if (error) throw error;
  return data as Gorev[];
}

export async function createGorev(gorev: Partial<Gorev>) {
  const { data, error } = await getSupabase().from('ilkimbutik_gorevler').insert(gorev).select().single();
  if (error) throw error;
  return data as Gorev;
}

export async function updateGorev(id: number, updates: Partial<Gorev>) {
  const { data, error } = await getSupabase().from('ilkimbutik_gorevler').update({ ...updates, guncelleme_tarihi: new Date().toISOString() }).eq('id', id).select().single();
  if (error) throw error;
  return data as Gorev;
}

export async function softDeleteGorev(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_gorevler').update({ silindi: true, aktif: false, silinme_tarihi: new Date().toISOString(), guncelleme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}

// ─── Referans Veriler ───
export async function fetchKaynaklar() {
  const { data, error } = await getSupabase().from('ilkimbutik_musteri_kaynaklari').select('*').eq('aktif', true).order('sira');
  if (error) throw error;
  return data as Kaynak[];
}

export async function fetchOdaTipleri() {
  const { data, error } = await getSupabase().from('ilkimbutik_oda_tipleri').select('*').eq('aktif', true).order('sira');
  if (error) throw error;
  return data as OdaTipi[];
}

export async function fetchOtelAyarlari() {
  const { data, error } = await getSupabase().from('ilkimbutik_otel_ayarlari').select('anahtar, deger');
  if (error) throw error;
  const map: Record<string, string> = {};
  (data || []).forEach((r: OtelAyar) => { map[r.anahtar] = r.deger; });
  return map;
}

export async function updateOtelAyar(anahtar: string, deger: string) {
  await getSupabase().from('ilkimbutik_otel_ayarlari').update({ deger, guncelleme_tarihi: new Date().toISOString() }).eq('anahtar', anahtar);
}

export async function fetchWhatsappSablonlari() {
  const { data, error } = await getSupabase().from('ilkimbutik_whatsapp_sablonlari').select('*').eq('aktif', true);
  if (error) throw error;
  return data as WhatsAppSablon[];
}

export async function fetchPersonel() {
  const { data, error } = await getSupabase().from('ilkimbutik_personel').select('*').eq('aktif', true);
  if (error) throw error;
  return data as Personel[];
}

// ─── Temizlik ───
export async function fetchTemizlikKayitlari() {
  const { data, error } = await getSupabase().from('ilkimbutik_oda_temizlik_kayitlari').select('*').eq('aktif', true).order('olusturma_tarihi', { ascending: false });
  if (error) throw error;
  return data as TemizlikKaydi[];
}

export async function createTemizlikKaydi(kayit: Partial<TemizlikKaydi>) {
  const { data, error } = await getSupabase().from('ilkimbutik_oda_temizlik_kayitlari').insert(kayit).select().single();
  if (error) throw error;
  return data as TemizlikKaydi;
}

// ─── Rezervasyon Geçmişi ───
export async function fetchRezervasyonGecmisi(rezervasyonId: number) {
  const { data, error } = await getSupabase().from('ilkimbutik_rezervasyon_gecmisi').select('*').eq('rezervasyon_id', rezervasyonId).order('olusturma_tarihi', { ascending: false });
  if (error) throw error;
  return data as RezervasyonGecmisi[];
}

// ─── WhatsApp Link Helper ───
export function formatWhatsappLink(phone: string, message: string): string {
  let cleaned = phone.replace(/[\s()\-]/g, '');
  if (cleaned.startsWith('0')) cleaned = '90' + cleaned.substring(1);
  if (!cleaned.startsWith('90')) cleaned = '90' + cleaned;
  return `https://wa.me/${cleaned}?text=${encodeURIComponent(message)}`;
}

export async function softDeleteMusteri(id: number) {
  const { error } = await getSupabase().from('ilkimbutik_musteriler').update({ silindi: true, aktif: false, silinme_tarihi: new Date().toISOString(), guncelleme_tarihi: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
}